import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { Box, Typography } from "@material-ui/core";
import { SectionContainer } from "../../styled/StyledComponents";
import SubmitButton from "../../submit-button/SubmitButton";
import { useRouter } from "next/router";
import { SEND_EMAIL_DISABLED_TIME } from "@containers/SignUp/constants";
import { sendVerificationEmail } from "@services/auth";
import { secondsToTimeString } from "@utils/index";
import ResendEmail from "./ResendEmail";

const useStyles = makeStyles((theme) => ({
  bgImage: {
    height: 346,
    margin: "auto",
    background:
      "url('/static/images/backgrounds/oops-image.png') center center no-repeat",
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    paddingTop: 32,
  },
  textContent: {
    "& p": {
      fontSize: 16,
      maxWidth: 240,
      margin: "auto",
    },
    "& .email": {
      padding: "16px 0 97px",
    },
  },
  notReceiveText: {
    color: theme.palette.primary.primaryB,
    fontSize: 12,
    marginBottom: 34,
  },
}));

export default function Oops({ user }) {
  const classes = useStyles();

  const [isResendSuccess, setIsResendSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [second, setSecond] = useState(SEND_EMAIL_DISABLED_TIME);
  const [shouldCount, setShouldCount] = useState(false);
  const secondRef = useRef();
  secondRef.current = second;

  const router = useRouter();
  const { email } = router.query || {};

  useEffect(() => {
    let interval;
    if (shouldCount) {
      interval = setInterval(() => {
        setSecond((second) => second - 1);
        if (secondRef?.current === 0) {
          setShouldCount(false);
          clearInterval(interval);
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [shouldCount]);

  const onSendVerificationEmail = async ({ isResend }) => {
    if (email) {
      setIsLoading(true);
      const response = await sendVerificationEmail(email);
      const { isSuccess, errorCode } = response || {};

      if (isSuccess) {
        if (isResend) {
          setShouldCount(true);
        } else {
          setIsResendSuccess(true);
          setShouldCount(true);
        }
      } else if (errorCode === "USER-0013") {
        router.push("/login");
      }

      setIsLoading(false);
    } else return;
  };

  return (
    <>
      {isResendSuccess ? (
        <ResendEmail
          onSendVerificationEmail={onSendVerificationEmail}
          shouldCount={shouldCount}
          isLoading={isLoading}
          second={second}
          user={user}
        />
      ) : (
        <SectionContainer className={classes.root}>
          <Box padding="36px 36px 0">
            <Box className={classes.bgImage}></Box>
            <Box>
              <Typography className={classes.title} align="center">
                Oops something went wrong!
              </Typography>
              <Box className={classes.textContent}>
                <Typography align="center">
                  Are your details correct? Check the details you provided
                </Typography>
                <Typography className="fw-bold email" align="center">
                  {email}
                </Typography>
              </Box>
              <Typography className={classes.notReceiveText} align="center">
                Did not receive verification email?
              </Typography>
              {shouldCount && (
                <Typography align="center" style={{ marginBottom: 8 }}>
                  {secondsToTimeString(second)}
                </Typography>
              )}
            </Box>
          </Box>
          <SubmitButton
            fontSize="24px"
            onClick={onSendVerificationEmail}
            disabled={(!!second && shouldCount) || isLoading}
          >
            Resend E-mail
          </SubmitButton>
        </SectionContainer>
      )}
    </>
  );
}
